import { Controller } from "@hotwired/stimulus"

// IntersectionObserver-based scroll spy for TOC sidebar highlighting
// + reading progress bar that fills as the user scrolls through the page
// Registered as "docs--scroll-spy"
export default class extends Controller {
  static targets = ["link", "progressBar"]

  connect() {
    this._observer = new IntersectionObserver(
      (entries) => this._onIntersect(entries),
      { rootMargin: "-80px 0px -80% 0px", threshold: 0 },
    )

    // Observe all section headings referenced by TOC links
    this.linkTargets.forEach((link) => {
      const sectionId = link.dataset.sectionId
      if (sectionId) {
        const heading = document.getElementById(sectionId)
        if (heading) this._observer.observe(heading)
      }
    })

    // Reading progress bar
    this._boundScroll = this._onScroll.bind(this)
    window.addEventListener("scroll", this._boundScroll, { passive: true })
    this._onScroll() // init on connect
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
    window.removeEventListener("scroll", this._boundScroll)
  }

  // Private

  _onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this._activateLink(entry.target.id)
      }
    })
  }

  _activateLink(sectionId) {
    this.linkTargets.forEach((link) => {
      const isActive = link.dataset.sectionId === sectionId
      link.classList.toggle("text-foreground/60", !isActive)
      link.classList.toggle("text-primary", isActive)
      link.classList.toggle("font-medium", isActive)
      link.classList.toggle("bg-primary/5", isActive)
    })
  }

  _onScroll() {
    if (!this.hasProgressBarTarget) return
    const scrollTop = window.scrollY
    const docHeight = document.documentElement.scrollHeight - window.innerHeight
    const progress =
      docHeight > 0 ? Math.min((scrollTop / docHeight) * 100, 100) : 0
    this.progressBarTarget.style.height = `${progress}%`
  }
}
